import { CardAction, ChickletHoverActions } from '../../../constants/BehaviorTypes';
import { DemoPortalCardAction } from './DemoPortalCardAction';
import { DemoPortalChickletHoverActions } from './DemoPortalChickletHoverActions';
export const DemoPortal = {
  [CardAction]: () => DemoPortalCardAction,
  [ChickletHoverActions]: () => DemoPortalChickletHoverActions
};